import {Placeholder} from 'react-bootstrap'
import {app_id} from '../../../../../app/modules/config'
import {useRittApp} from '../../../../../app/utils/contextProvider/RittAppProvider'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuMain} from './SidebarMenuMain'
import {useUserStateProvider} from '../../../../../app/utils/contextProvider/UserStateProvider'
import {SidebarMenuRoleWise} from './SidebarMenuRoleWise'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenu = () => {
  const {notification} = useRittApp()
  const {currentUser} = useAuth()
  const {loadingMenu, sidebarFooterMenus} = useUserStateProvider()
  const unreadNotification = notification?.filter((note) => note.status === '0')

  return (
    <div className='app-sidebar-menu overflow-hidden flex-column-fluid'>
      <div
        id='kt_app_sidebar_menu_wrapper'
        className='app-sidebar-wrapper hover-scroll-overlay-y scroll-y my-5 h-550px border-bottom'
        data-kt-scroll='true'
        data-kt-scroll-activate='true'
        data-kt-scroll-height='auto'
        data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
        data-kt-scroll-wrappers='#kt_app_sidebar_menu'
        data-kt-scroll-offset='5px'
        data-kt-scroll-save-state='true'
      >
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3'
          id='#kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
        >
          {loadingMenu ? (
            <>
              {[0, 1, 2, 3, 4].map((el) => (
                <div key={el}>
                  <Placeholder
                    as='p'
                    animation='glow'
                    className='mx-2 h-40px w-220px rounded-1 border-0 mt-4'
                  >
                    <Placeholder className='rounded-1 h-100 w-100 border-0' />
                  </Placeholder>
                </div>
              ))}
            </>
          ) : (
            <>{currentUser?.author_id === 0 ? <SidebarMenuMain /> : <SidebarMenuRoleWise />}</>
          )}
        </div>
      </div>

      <div
        id='kt_app_sidebar_menu_wrapper'
        className='app-sidebar-wrapper hover-scroll-overlay-y scroll-y'
        data-kt-scroll='true'
        data-kt-scroll-activate='true'
        data-kt-scroll-height='auto'
        data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
        data-kt-scroll-wrappers='#kt_app_sidebar_menu'
        data-kt-scroll-offset='5px'
        data-kt-scroll-save-state='true'
      >
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3'
          id='#kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
        >
          {loadingMenu ? (
            <>
              {[0, 1, 2].map((el) => (
                <div key={el}>
                  <Placeholder
                    as='p'
                    animation='glow'
                    className='mx-2 h-40px w-220px rounded-1 border-0 mt-4'
                  >
                    <Placeholder className='rounded-1 h-100 w-100 border-0' />
                  </Placeholder>
                </div>
              ))}
            </>
          ) : (
            <>
              {sidebarFooterMenus.slice(0, 2).map((menu) => {
                if (menu.view_level === 'Y') {
                  return (
                    <>
                      <SidebarMenuItem
                        to={menu.menu_link}
                        icon={menu.icon}
                        title={menu.menu_name}
                        classes='d-flex'
                      >
                        {menu.menu_name.toLowerCase() === 'notificaiton' && (
                          <span className='badge badge-danger' style={{lineHeight: '.8'}}>
                            {unreadNotification?.length}
                          </span>
                        )}
                      </SidebarMenuItem>
                    </>
                  )
                }
              })}
              {currentUser?.author_id === 0 && (
                <>
                  <SidebarMenuItem
                    to='/account-settings/notifications'
                    icon='notification'
                    title='Notifications'
                    classes='d-flex'
                  >
                    <span className='badge badge-danger' style={{lineHeight: '.8'}}>
                      {unreadNotification?.length}
                    </span>
                  </SidebarMenuItem>
                  <SidebarMenuItem
                    to='/profile/settings'
                    icon='profile-user'
                    title='Profile Settings'
                  />
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export {SidebarMenu}
